import styled from 'styled-components';

export const ReviewRatingWrapper = styled.div`
    width: 68%;
    height: 75%;
    display: flex;
    padding: 4rem;
    justify-content: space-between;
    background-color: #fff;
`;

export const RatingsWrapper = styled.div`
    flex-basis: 30%;
    .fillBar {
        height: 100%;
        border-radius: 0.2rem;
    }
`;

export const ReviewWrapper = styled.div`
    flex: 1;
    border-left: solid 1px #f5f5f5;
    padding-left: 2rem;
    margin-left: 2rem;
    .loading {
        height: 100%;
        width: 100%;
    }
`;

export const CloseIconWrapper = styled.div`
    flex-basis: 2%;
`;

export const ReviewWrapperLeft = styled.div`
    width: 790px;
    flex-shrink: 0;
`;

export const ReviewContainer = styled.div`
    padding-bottom: 2rem;
    height: 100%;
    overflow: auto;
    .nameWrapper {
        height: 2.7rem;
        width: 2.7rem;
        background-color: #d8d8d8;
        color: #000;
        border-radius: 50%;
    }
    .reviewContainer {
        margin-top: 2rem;
        padding-top: 2rem;
        border-top: solid 1px #f5f5f5;
    }
`;

export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,0.3);
`

export const RatingTag = styled.span`
  width: 4.2rem;
  height: 2.1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.4rem;
  font-size: 1.1rem;
  color: #fff;
  margin-left: 1rem;
  > span:first-child {
    font-weight: 600;
  }
  ${(props) =>
    props.bc &&
    `
        background-color: ${props.bc};
    `}
`;

export const RatingBar = styled.div`
    background-color: #e1e7ee;
    border-radius: 0.2rem;
    flex: 1;
    height: 0.4rem;
    margin: 0 1.2rem;
    width: 13.8rem;
`;

export const ReviewWrapperRight = styled.div`
    width: 390px;
    flex-shrink: 0;
    position: sticky;
    top: 16px;
    margin-bottom: 16px;
    height: max-content;
`;

export const RatingContainer = styled.div`
    padding: 2rem 0 0;
    display: flex;
    align-items: center;
    .width25 {
        width: 2.5rem;
    }
    .RatingContainerLeft {
        height: 9rem;
        width: 10rem;
        border-radius: 0.7rem;
        margin-right: 2rem;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .star {
        position: relative;
        display: inline-block;
        width: 0;
        height: 0;
        margin-left: .9em;
        margin-right: .9em;
        margin-bottom: 1.2em;
        border-right:  .3em solid transparent;
        border-bottom: .7em  solid #0a2549;
        border-left: .3em solid transparent;
        font-size: 0.4em;
        &:before, &:after {
          content: '';
          display: block;
          width: 0;
          height: 0;
          position: absolute;
          top: .5em;
          left: -1em;
          border-right:  1em solid transparent;
          border-bottom: .7em  solid #0a2549;
          border-left:   1em solid transparent;
          transform: rotate(-35deg);
        }
        &:after {  
          transform: rotate(35deg);
        }
      }
`;

export const RatingBarWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 4rem;
    padding-top: 2rem;
    border-top: solid 1px #f5f5f5;
`;

export const BoxContainer = styled.div`
    width: ${p => p.boxWidth ? p.boxWidth : ''};
    height: ${p => p.boxHeight ? p.boxHeight : ''};
    border-radius: ${p => p.borderRadius ? p.borderRadius : ''};
    background-color: ${p => p.bgColor ? p.bgColor : ''};
    margin: ${p => p.margin ? p.margin : ''};
    padding: ${p => p.padding ? p.padding : ''};
    box-shadow: ${p => p.shadow ? p.shadow : ''};
`;